import TagModel from './TagModel';

export const DEFAULT_WEBVIEW_HEIGHT = 'full';

export type WebviewHeightRatio = 'full' | 'tall' | 'compact';

export const WebviewOptions = [
  { id: 'full', name: 'Full (100%)' },
  { id: 'tall', name: 'Medium (75%)' },
  { id: 'compact', name: 'Compact (50%)' },
];

export enum ButtonType {
  PAGE = 'page',
  URL = 'url',
  CALL = 'call',
  SHARE = 'share',
  POSTBACK = 'postback',
  EMAIL = 'email',
  PHONE_NUMBER = 'phone_number',
  LOCATION = 'location',
  HANDOVER = 'handover',
  OPT_IN = 'opt_in',
}

export type PhoneNumberButtonConfig = {
  phoneNumber: string;
};

export type PageButtonConfig = {
  pageId: number;
  assetId: number;
  uploadId: number;
  file: string;
  pageHidden?: boolean;
};

export type ConnectionButtonConfig = {
  payload: string;
  assetId: number;
  uploadId: number;
  file: string;
};

export type UrlButtonConfig = {
  url: string;
  webviewHeightRatio?: WebviewHeightRatio;
};

export type HandoverButtonConfig = {
  appId: string;
  metadata: string;
};

export type OptInButtonConfig = {
  kind: 'sms' | 'text' | 'facebook';
  smsResponse: string;
  pageId: number | null;
  hidden?: boolean;
};

export type ButtonConfig =
  | PhoneNumberButtonConfig
  | PageButtonConfig
  | ConnectionButtonConfig
  | UrlButtonConfig
  | HandoverButtonConfig
  | OptInButtonConfig
  | {}; // Some buttons return empty configs

export type GenericButtonModel<T> = {
  id: number;
  name: string;
  type: ButtonType;
  sortOrder: number;
  validated: boolean;
  tags?: TagModel[];
  clickThrough?: number | 'N/A';
  viewsCount?: number | 'N/A';
  config: T;
};

export default interface ButtonModel {
  id: number;
  name: string | null;
  type: ButtonType;
  sortOrder: number;
  validated?: boolean;
  tags?: TagModel[];
  clickThrough?: number | 'N/A';
  viewsCount?: number | 'N/A';
  clicksCount?: number;
  config: ButtonConfig;
}

export type ButtonRequestModel = {
  type: ButtonType;
  name: string;
  sortOrder: number;
  id?: number;
  tags?: TagModel[];
  config: ButtonConfig;
  validated?: boolean;
};
